import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import MyTable, { TableRow } from "../../../components/MyTable";
import { resetRecordsSort, searchEmployeeRecords, setRecordsSort } from "../../../store/slices/documents";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "./downloadButtonDocument";
import { EMPLOYEE_RECORDS_ONE, EMPLOYEE_RECORDS_THREE, EMPLOYEE_RECORDS_TWO, RECORD_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { useEffect, useState } from "react";
import { CardContent, Grid, Typography } from "@mui/material";
import { formatDateToTimestamp } from "../../../utils/date";


interface TableRecordsProps {
    numberOfCards?: number;
    changeViewOptionHidden?: boolean;
    startDate?: Date;
    endDate?: Date;
    requestId: (typeof EMPLOYEE_RECORDS_ONE | typeof EMPLOYEE_RECORDS_TWO |  typeof EMPLOYEE_RECORDS_THREE)

    status?: 0 | 1 | 2;

    hiddenBottomPaginator?: boolean;
    hiddenFilterOptions?: boolean;
}

const TableRecords = ({requestId, hiddenFilterOptions, status, ...props}: TableRecordsProps) => {
    const documents = useSelector((state: RootState) => state.documents[requestId]);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const [startDate, setStartDate] = useState<Date | null>(props.startDate || null);
    const [endDate, setEndDate] = useState<Date | null>(props.endDate || null);

    const employeeRecordsTableHeadRows = [
        {
            label: "Periodo",
            rowKeyName: "Periodo",
            buildOrderValue: (row: string) => {
                const value = row.split(" ").slice(1, 5).join("")
                return value
            },
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroDocumento",
            allowOrderAction: true,
        },{
            label: "Tipo de documento",
            rowKeyName: "TipoDocumento",
            allowOrderAction: true,
        },{
            label: "Fecha de envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },
        {
            label: "Fecha de firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },
        {
            label: "",
            rowKeyName: "viewFile",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => (
                <DownloadButtonDocument
                    FirmaTop={row.FirmaTop}
                    NroFs={row.NroFS}
                    
                    userDocument={row.DNI}
                    ruc={row.RUC}
                    documentNumber={row.NumeroDocumento}
                    documentType={row.TipoDocumento}

                    FirmadoFecha={row.FirmadoFecha} 
                    IdDocument={row.NroBoletaNomina}
                    requestId={RECORD_DOCUMENT_SIGNATURE_REQUEST}
                />
            ),
        }
    ,];

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        dispatch(resetRecordsSort(requestId));
        dispatch(searchEmployeeRecords((status || 0), requestId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId]);

    return (
        <MyTable
            key="tab-3"
            hiddenFilterOptions={hiddenFilterOptions}
            calculateLimitDate={true}
            dateFilterField={'FechaEnviadoPortal'}
            tableHeadRows={employeeRecordsTableHeadRows}
            tableRows={documents.records}
            setOrderedData={(sortField: any, sortType: any, rowData: any) => dispatch(setRecordsSort({sortField, sortType, rowData, requestId}))}
            sortField={documents.recordsSortField}
            sortType={documents.recordsSort}
            loading={documents.recordsLoading}
            selectControlProps={hiddenFilterOptions ? undefined : {
                label: "Tipo de documento",
                autocalculateFieldName: "TipoDocumento"
            }}
            rangeControlProps={{
                startDate: startDate,
                endDate: endDate,
                setEndDate: setEndDate,
                setStartDate: setStartDate,
            }}
            cardComponent={{
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            {/* <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem">
                                {row.TipoDocumento} 
                            </Typography> */}
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary" marginBottom=".2rem">
                                    {row.TipoDocumento}
                                    </Typography>
                                </Grid>
                                <Grid item maxWidth="2rem">
                                    <DownloadButtonDocument
                                        FirmaTop={row.FirmaTop}
                                        NroFs={row.NroFS}
                                        
                                        userDocument={row.DNI}
                                        ruc={row.RUC}
                                        documentNumber={row.NumeroDocumento}
                                        documentType={row.TipoDocumento}

                                        FirmadoFecha={row.FirmadoFecha} 
                                        IdDocument={row.NroBoletaNomina}
                                        requestId={RECORD_DOCUMENT_SIGNATURE_REQUEST}
                                    />
                                </Grid>
                            </Grid>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                #: {" "}
                                <Typography variant="body2" component="span">
                                    {row.NumeroDocumento}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Periodo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Periodo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo Doc.: {" "}
                                <Typography variant="body2" component="span">
                                    {row.TipoDocumento}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Envío: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaEnviadoPortal) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Firma: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FirmadoFecha) as any}
                                </Typography>
                            </Typography>
                            
                        </CardContent>
                    );
                },
                numberOfCards: props?.numberOfCards,
                changeViewOptionHidden: props?.changeViewOptionHidden,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={props?.hiddenBottomPaginator}
        />
    )
}

export default TableRecords;